module.exports = __webpack_public_path__ + "static/media/higuchi-building-6.9760cc29.jpg";